const sessionURL = process.env.VUE_APP_SESSION_URL

export default {
  install: function(app) {
    // 添加全局的方法
    app.config.globalProperties.userSession = function() {
      if (sessionStorage.getItem('openid') == null ||
                sessionStorage.getItem('openid') === '' ||
                sessionStorage.getItem('openid') === undefined ||
                sessionStorage.getItem('token') == null ||
                sessionStorage.getItem('token') === '') {
        window.location.href = sessionURL
      }
    }
  }
}
